// extracted by mini-css-extract-plugin
export var share = "bB_ff";
export var text = "bB_fg";